var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightIcnHelp16 = function SvgLightIcnHelp16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#6D7D90",
    strokeWidth: 0.7,
    d: "M14.906 9A5.906 5.906 0 1 1 3.094 9a5.906 5.906 0 0 1 11.812 0Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6D7D90",
    fillRule: "evenodd",
    d: "M8.993 11.456a.6.6 0 0 0-.433.175.59.59 0 0 0-.178.436q0 .256.178.435a.6.6 0 0 0 .433.177q.263 0 .438-.178a.6.6 0 0 0 .175-.434.6.6 0 0 0-.613-.611M10.977 6.395a1.9 1.9 0 0 0-.74-.656 2.34 2.34 0 0 0-1.077-.242c-.43 0-.804.086-1.111.254q-.466.252-.72.68a2.2 2.2 0 0 0-.297.934l-.012.146h.793l.011-.12q.038-.343.208-.602.169-.256.452-.401.283-.144.652-.145.374 0 .659.145.283.145.444.397.158.25.158.587 0 .245-.078.446a1.1 1.1 0 0 1-.254.376 3 3 0 0 1-.484.385q-.345.228-.567.46-.226.233-.33.504c-.07.178-.104.383-.104.607v.546h.808v-.453q0-.262.069-.447a.94.94 0 0 1 .233-.348 3 3 0 0 1 .485-.372 2.7 2.7 0 0 0 .792-.75q.277-.42.278-.994a1.7 1.7 0 0 0-.268-.937",
    clipRule: "evenodd"
  })));
};
export default SvgLightIcnHelp16;